module.exports = __webpack_public_path__ + "static/hero-lxp-d178bceaafe5d3dfd655de8b7391bb09.svg";